import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";
import {FormattedMessage} from 'react-intl'
import * as wConsts from "../consts/website-consts";
import {Link} from "react-router-dom";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
import SideBanners from "../components/sidebanners";
class Login extends Component {



  constructor(props) {
    super(props);
    this.state = {
      Username: "", Password: "", RememberMe: false,

    }
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "login" });

  }

  componentDidMount() {
    //this.props.pageHandler('home');
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  handleSubmit(evt) {
    evt.preventDefault();
    let dta = this.state;
    dta.FailText = this.getTranslation("response.wrongloginorpassword")
    dta.SuccessText = this.getTranslation("response.loginsuccessful");
    this.props.dispatch(wActs.loginNow({Username: this.Username.value, Password: this.Password.value, FailText: dta.FailText, SuccessText: dta.SuccessText}));
  }


  getSignup() {
    return wActs.getCultPath(this.props.WebPage, "/signup");
  }

  handlePress(evt) {
    if(evt.key === 'Enter') {
      this.handleSubmit(evt);
    }
  }
  handleChange(evt) {
    const target = evt.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    })
  }

  handleErrorClose(evt) {
    this.props.dispatch(wActs.clearLoginError());
  }

  PopupCenter(url, title, w, h) {
    const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }

    return newWindow;
  }


  handleENewsClick(evt) {
    evt.preventDefault();
    this.PopupCenter("https://auth.escortnews.eu/auth/login", "loginWindow", 410, 515);
    window.addEventListener("message", function (event) {
      //if (event.origin.toLowerCase().indexOf("oauth") > 0) {
        if (event.data.token_type === "Bearer") {
          let domain = "." + wActs.getSubdomain(window.location.hostname);
          wActs.setCookie("auth", event.data.access_token, { path: "/", maxAge: 31557600, domain: domain });
          window.location = "/";
        }
      //} else {
      //  console.log("Bad Origin", event);
      //}
    }, false);
  }


  render() {
    let status = this.props.WebPage.User.LoginStatus;
    let centerBan = "four-center-banner" + wActs.MainLeftStyle(this.props.WebPage);
    return (
      <div className={``}>
        <SeoHeaders Position={"Top"}/>
        <div className="row">
          <div className={"col_80"}>
            <div className="white-box the-content">
              <div className="heading">
                <div className="cell x12">
                  <p>{this.getTranslation("page.login.donthaveanaccount")} <Link to={this.getSignup()}>{this.getTranslation("page.login.registerhere")}</Link></p>
                </div>
                <div className="clear"></div>
              </div>
              <div className="form">
                <div className="cell x12">
                  <form action="">
                  <p className="w-icon username" style={{maxWidth: "100%"}}><input onKeyPress={(e)=>{this.handlePress(e)}} ref={(r)=>{this.Username = r}} type="text" placeholder={this.getTranslation("page.login.username")}/></p>
                  <p className="w-icon password" style={{maxWidth: "100%"}}><input onKeyPress={(e)=>{this.handlePress(e)}} ref={(r)=>{this.Password = r}} type="password" placeholder={this.getTranslation("page.login.password")}/></p>

                  {status === wConsts.LOGIN_STATUS_PENDING && <img src={"/imgs/loader.gif"} width={"58"} height={"58"} alt={"loading..."} style={{margin: "auto", contentAlign: "center", justifyContent: "center", display: "flex"}}/>}
                  {status !== wConsts.LOGIN_STATUS_PENDING && <input onClick={(e)=> {this.handleSubmit(e)}}  type="submit" value={this.getTranslation("page.submit")}/>}

                  </form>

                  <div className="or">
                    <div className="centered-content small-mt"><Link to={wActs.getCultPath(this.props.WebPage,"/reset-password")} title=""><FormattedMessage id={"page.login.forgotpassword"}>{(...content) => content}</FormattedMessage></Link></div>
                  </div>

                  <div className="socials-login" style={{borderTop: "solid 1px #ccc", padding: "10px 0px"}}>
                    <a onClick={(e) => {this.handleENewsClick(e)}} href="#" className="btn red">{this.getTranslation("page.login.loginwithyourescortnewsaccount")}</a>
                  </div>
                </div>
                <div className="clear"></div>
              </div>
            </div>


          </div>
          <SideBanners/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Login);
